// hooks/useCommisonMerchant.js or .ts
import { commonServiceInstance } from "api";
import useSWR from "swr";

const useProfileData = () => {
  const {
    data: profile,
    error,
    mutate,
  } = useSWR(
    `/profile/details`,
    async (url) => {
      const {
        data: { value },
      } = await commonServiceInstance.get(url);

      return value;
    },
    {
      revalidateIfStale: false,
    }
  );

  return { profile, error, refetch: mutate };
};

export default useProfileData;
